{
  "archived": "Archived",
  "fieldServiceTag": "Field service",
  "actions": {
    "new": "New team",
    "board": "Open board",
    "newTask": "New task",
    "archive": "Archive",
    "restore": "Restore"
  },
  "fields": {
    "name": "Name",
    "nameAr": "Name in Arabic",
    "description": "Description",
    "allowSelfClaim": "Members may take tasks from the queue",
    "fieldService": "Makes service visits",
    "members": "Members",
    "leads": "Leads",
    "memberCount": "Members",
    "myRole": "Your role"
  },
  "counts": {
    "open": "Open",
    "unassigned": "Unassigned",
    "overdue": "Overdue",
    "blocked": "Blocked",
    "inReview": "In review"
  },
  "list": {
    "title": "Teams",
    "intro": "Who owns which work. A team can mix people from several departments.",
    "views": "Team views",
    "view": {
      "active": "Active",
      "mine": "Mine",
      "archived": "Archived"
    },
    "searchPlaceholder": "Search teams",
    "searchLabel": "Search teams",
    "tableLabel": "Teams",
    "empty": {
      "filteredTitle": "No team matches this search",
      "title": "No teams yet",
      "body": "Create a team, add its people and choose its leads. Work for the team then waits in its queue.",
      "view": {
        "active": "No active teams.",
        "mine": "You are not a member of any team.",
        "archived": "No archived teams."
      }
    },
    "clearSearch": "Clear search",
    "card": {
      "yourRole": "Your role:",
      "noLeads": "No lead yet",
      "noMembers": "No members yet",
      "membersLabel": "Members: {{names}}"
    }
  },
  "form": {
    "newTitle": "New team",
    "newBody": "A team owns work. Its leads review it and share it out.",
    "editTitle": "Edit team",
    "descriptionPlaceholder": "What the team takes care of",
    "hints": {
      "allowSelfClaim": "Otherwise only the team's leads hand out queued work.",
      "fieldService": "Field service teams are the ones offered for visits and shown on the service board.",
      "members": "Search people by name or e-mail. Several leads are allowed."
    },
    "addMember": "Add a person",
    "roleOf": "Role of {{name}}",
    "removeMember": "Remove {{name}}",
    "noMembers": "No members yet. The first person you add becomes a lead.",
    "create": "Create team",
    "errors": {
      "name": "Give the team a name.",
      "nameTaken": "Another team already has this name."
    }
  },
  "toast": {
    "created": "Team {{name}} created",
    "saved": "Team {{name}} saved",
    "archived": "Team {{name}} archived",
    "restored": "Team {{name}} restored"
  },
  "archive": {
    "title": "Archive {{name}}?",
    "body": "The team takes no new tasks or visits and leaves the team pickers. Its past work keeps it, and you can restore it later.",
    "restoreTitle": "Restore {{name}}?",
    "restoreBody": "The team can take tasks and visits again.",
    "confirm": "Archive team",
    "restoreConfirm": "Restore team",
    "hasOpenTasks_one": "This team still owns {{n}} open task. Move it to another team or finish it before archiving the team.",
    "hasOpenTasks_other": "This team still owns {{n}} open tasks. Move them to another team or finish them before archiving it.",
    "showOpenTasks": "Show its open tasks"
  },
  "workspace": {
    "memberCount_one": "{{n}} member",
    "memberCount_other": "{{n}} members",
    "myRole": {
      "LEAD": "You lead this team",
      "MEMBER": "You are a member",
      "none": "You are not a member"
    },
    "selfClaim": "Members take work from the queue",
    "leadsAssign": "Leads hand out queued work",
    "archivedBanner": "Archived on {{date}}. Restore the team to give it new work.",
    "attention": "Needs attention",
    "ofOpen": "of {{n}} open"
  },
  "queue": {
    "title": "Queue",
    "hint": "Unassigned work, oldest first. Take a task to make it yours.",
    "hintNoTake": "Unassigned work, oldest first.",
    "empty": "The queue is empty.",
    "take": "Take task",
    "takeLabel": "Take task {{number}}",
    "since": "In the queue since {{date}}",
    "waitingDays_one": "Waiting {{n}} day",
    "waitingDays_other": "Waiting {{n}} days",
    "waitingHours_one": "Waiting {{n}} hour",
    "waitingHours_other": "Waiting {{n}} hours",
    "waitingMinutes": "Waiting under an hour"
  },
  "showAll_one": "See {{n}} in Tasks",
  "showAll_other": "See all {{n}} in Tasks",
  "showAllShort": "See all",
  "openWork": {
    "title": "Team's open work",
    "empty": "Nothing open. New work for this team appears here."
  },
  "members": {
    "title": "Members",
    "empty": "No members yet. Add people so the team can take work.",
    "add": "Add members"
  },
  "errors": {
    "TEAM_HAS_OPEN_TASKS": "This team still owns open tasks. Move them to another team or finish them before archiving it.",
    "TEAM_HAS_OPEN_VISITS": "This team still has service visits scheduled or under way. Reschedule them to another team, finish or cancel them before archiving it.",
    "TEAM_HAS_OPEN_TASKS_moduleOff": "This team still owns open tasks, and Tasks is turned off for your company, so they can't be moved or finished. Keep the team until Tasks is turned back on.",
    "TEAM_HAS_OPEN_VISITS_moduleOff": "This team still has service visits scheduled or under way, and Service is turned off for your company, so they can't be rescheduled, finished or cancelled. Keep the team until Service is turned back on."
  }
}
